import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class WaiMatPaginatorIntl extends MatPaginatorIntl {
  constructor(private translateService: TranslateService) {
    super();
    this.getTranslations();
  }

  public getTranslations() {
    this.firstPageLabel = this.translateService.instant('INTL_PAGINATION_FIRST_PAGE');
    this.itemsPerPageLabel = this.translateService.instant('INTL_PAGINATION_ITEMS_PER_PAGE');
    this.lastPageLabel = this.translateService.instant('INTL_PAGINATION_LAST_PAGE');
    this.nextPageLabel = this.translateService.instant('INTL_PAGINATION_NEXT_PAGE');
    this.previousPageLabel = this.translateService.instant('INTL_PAGINATION_PREVIOUS_PAGE');
    this.changes.next();
  }

  public getRangeLabel = (page: number, pageSize: number, length: number): string => {
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    // Get the translated template
    const template = this.translateService.instant('INTL_PAGINATION_RANGE');

    // Extract all {{param}} placeholders dynamically
    const paramMatches = template.match(/\{\{([^}]+)\}\}/g) || [];

    // If no placeholders found, return template as-is
    if (paramMatches.length === 0) {
      return template;
    }

    // Create values array in the expected order: [start, end, total]
    const values = [(startIndex + 1).toString(), endIndex.toString(), length.toString()];

    // Replace each placeholder with the corresponding value by position
    let result = template;
    paramMatches.forEach((match, index) => {
      const value = values[index] || ''; // Use empty string if no corresponding value
      result = result.replace(match, value);
    });

    return result;
  };
}
